var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagotype = function SvgImagotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221 140.37"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "imagotype_svg__a",
    x1: 110.58,
    x2: 109.55,
    y1: 1998.58,
    y2: 1959.15,
    gradientTransform: "translate(0 -1920.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff840f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb910"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#imagotype_svg__a",
    id: "imagotype_svg__b",
    x1: 109.35,
    x2: 108.38,
    y1: 1998.01,
    y2: 1960.97
  }), /*#__PURE__*/React.createElement("style", null, ".imagotype_svg__a{fill:#2e398f;fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 111.31a310.4 310.4 0 0 0 91.3 0 310.4 310.4 0 0 0-91.3 0M42 100a696 696 0 0 0 136.9 0A696 696 0 0 0 42 100M19.2 88.71a1236.6 1236.6 0 0 0 182.6 0 1236.6 1236.6 0 0 0-182.6 0",
    className: "imagotype_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61 68.81c-.1 1.5-.2 3-.2 4.5a61 61 0 0 0 .5 7.4l49.1-1.5 49.1 1.5a45 45 0 0 0 .6-7.4 48.9 48.9 0 0 0-5.9-23c-16 11.1-39.2 21.1-61.2 23.6-13.7 1.5-24.7.5-30.9-4z",
    style: {
      fillRule: "evenodd",
      fill: "url(#imagotype_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 23.61a50.7 50.7 0 0 0-28.6 9.2 50.14 50.14 0 0 0-18.2 23.9c.5 3.3 3 6.2 9.5 8.7 23.7 9.1 57-4.5 80.5-16-8.6-15.2-25-25.8-43.2-25.8",
    style: {
      fillRule: "evenodd",
      fill: "url(#imagotype_svg__b)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.6 43.71a39 39 0 0 0-4.8-.6 1.9 1.9 0 0 0-.7.2c-.1.1-.4.2-.4.3s.3.3.6.4l2.9 1.2-2.3 1.5c-1.2.8-.8.8-2.8-.3-.2-.1-.3-.2-.5-.2-1.1.2-.4.8-.1 1.4l1 1.6a1.28 1.28 0 0 0 1.5.5 14 14 0 0 0 4.1-1.9l1.2-.8a39 39 0 0 1-.2 4.8v.4c0 .2 0 .3.2.3a1.56 1.56 0 0 0 .8-.6l.3-.6 1.7-5.8c.2-.6.1-.3.9-.9l.7-.5c.5-.4 3-2 2.9-2.5 0-.2-.6-.5-.8-.6a2.8 2.8 0 0 0-.9-.1 5 5 0 0 0-2.9 1.2Z",
    className: "imagotype_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h221v140.37H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgImagotype;